import {JsonProperty} from '@hyperloris/tyson';

export class CrystalclearHealth {
  @JsonProperty()
  status: String | undefined;
}
